import { store } from '../../../../../resources/frontend/js/store/index';
import { sendLead } from '@form/utils/send-lead';
import { setupRecaptcha } from '@form/utils/recaptcha';
import mapSpecialCharacters from '@mixins/utils/map-special-characters';
import { usePage } from '@inertiajs/vue3';

export const submitStep = () => {
    const data = [];
    let testConversion = false;
    let checkMode = false;

    for (const field of store.getters['form/getFormData']()) {
        if (typeof field.value === 'string' && field.value.indexOf('sbtest') > -1) {
            testConversion = true;
        }

        data.push({
            name: `${field.name}[name]`,
            value: field.name,
        });

        data.push({
            name: `${field.name}[question]`,
            value: field.question || field.name,
        });

        if (field.dataType === 'Email') {
            data.push({
                name: `${field.name}[value]`,
                value: mapSpecialCharacters(field.value),
            });

            data.push({
                name: `${field.name}[label]`,
                value: field.label || mapSpecialCharacters(field.value),
            });
        } else {
            data.push({
                name: `${field.name}[value]`,
                value: field.value,
            });

            data.push({
                name: `${field.name}[label]`,
                value: field.label || field.value,
            });
        }
    }

    for (const extraData of Object.values(store.state.quiz.extradata)) {
        if (extraData.sendData === false) continue;

        data.push({
            name: `${extraData.name}[name]`,
            value: extraData.name,
        });

        data.push({
            name: `${extraData.name}[question]`,
            value: extraData.question || extraData.name,
        });

        data.push({
            name: `${extraData.name}[value]`,
            value: extraData.value,
        });

        data.push({
            name: `${extraData.name}[label]`,
            value: extraData.label || extraData.value,
        });
    }

    if (
        store.state.page.productType !== 'marketplaces'
        && store.state.page.leadService !== 'sherlock'
        && testConversion
    ) {
        data.forEach(input => {
            // filter all ending with [name] and remove [name] to get the input name
            if (!input.name.endsWith('[name]')) return;

            const name = input.name.replace(/\[name]/g, '');
            const dataType = store.getters['form/getFieldData']('dataType', input.name) || 'Unspecified';

            data.push({
                name: `input_types[${name}]`,
                value: dataType,
            });
        });
    }

    if (store.state.form.attributes.step !== store.state.form.attributes.amountOfSteps) {
        data.push({
            name: 'options[checkMode]',
            value: checkMode,
        });

        checkMode = true;
    }

    const LeadSystemData = new FormData();

    for (const row of data) {
        LeadSystemData.append(row.name, row.value);
    }

    const page = usePage();

    if (
        (
            store.state.page.productType === 'marketplaces'
            || !store.state.page.isLanding
            || !!page.props.sms_verification
            || store.state.page.leadService === 'sherlock'
            || page.props.page.hasActiveThankYouForm === true
        )
        && checkMode
    ) {
        store.commit('form/setAttribute', { key: 'step', value: store.state.form.attributes.step + 1 });
        store.commit('form/setAttribute', { key: 'loading', value: false });
        store.commit('page/increasePixelStep', { label: 'Form' });
        return;
    }

    if (store.state.page.recaptchaKey) {
        setupRecaptcha(LeadSystemData);
        return;
    }

    sendLead(LeadSystemData);
};

export const submitForm = () => {
    if (!store.state.page.isLanding) {
        store.state.form.state = 'thankyou';
        return;
    }

    setTimeout(() => {
        document.querySelector('#thankyouForm').submit();
    });
};
